"use strict";

jQuery(document).ready(function () {

  var plc = jQuery('#sc_cart_slide'); //sc_fnc_scli_increment_item(item_id)

  plc.on('click', '.qty_ctrl_plus', function () {
    var elm = jQuery(this);
    var qty_box = elm.closest('.qty_box');
    var item_id = qty_box.data('item_id');
    var qty = qty_box.data('qty');
    sc_fnc_scli_change_item_qty(item_id, ++qty);
  });
  plc.on('click', '.qty_ctrl_minus', function () {
    var elm = jQuery(this);
    var qty_box = elm.closest('.qty_box');
    var item_id = qty_box.data('item_id');
    var qty = qty_box.data('qty');
    sc_fnc_scli_change_item_qty(item_id, --qty);
  });
  sc_fnc_minicart_lnk_event();
  jQuery('#sc_cart_slide_overlay').on('click', function () {
    sc_fnc_hide_sc_cart_slide();
  });
});

function sc_fnc_minicart_lnk_event() {
  jQuery('.cart-link a').on('click', function (event) {
    event.preventDefault();
    
    jQuery.getJSON('/cart.js', function(cart) {
      let items = cart.items;
      var count = cart.item_count
      var length = items.length
      //   alert(length);
      if (length > 2) {
        jQuery('.viewEntireCart').show();
      }else{
        jQuery('.viewEntireCart').hide();
      }
    });
    
    sc_fnc_load_cart_data();
    sc_fnc_show_sc_cart_slide();

  });
}

function sc_snc_on_product_add_to_cart() {
  console.log('Called: add_to_car 500');
  var $add_to_cart_form = jQuery('form[action="/cart/add"]').serialize(); //jQuery('#frm_prodct_add_to_cart').serialize();
	
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: $add_to_cart_form,
    dataType: 'json',
    "Content-Type": "application/json",
    crossDomain: true
  }).done(function (response) {
    //HttpContext.Current.Response.AddHeader("Access-Control-Allow-Origin","*");
    //       console.log('cart add response:');

    
    
    sc_fnc_get_cart_data(function (cart_data) {
      sc_fnc_popualte_data(cart_data, function () {
        sc_fnc_show_sc_cart_slide(); //sc_fnc_update_continue_shopping_url(cart_data);
      });
    });
    
    jQuery.getJSON('/cart.js', function(cart) {
      let items = cart.items;
      var count = cart.item_count
      var length = items.length
 //   alert(length);
 //	  console.log(length + '--555');
      if (length > 2) {
        jQuery('.viewEntireCart').show();
      }else{
        jQuery('.viewEntireCart').hide();
      }
    });
    
    
  }).fail(function (response) {
    var responseText = JSON.parse(response.responseText);
    alert(responseText);
  });
  return false;
}

function sc_fnc_update_continue_shopping_url(cart_data) {
  var plc = jQuery('#sc_cart_slide');
  if (plc.length == 0) return false;
  var items = cart_data.items ? cart_data.items : [];
  var item_count = cart_data.item_count ? cart_data.item_count : 0;
  var items_count = items.length ? items.length : item_count;
  if (items_count <= 0) return false;
  var item = items[items_count - 1];
  var item_handle = item.handle ? item.handle : ''; //var item_url = item.url? item.url : '';

  if (item_handle != '') {
    var continue_shopping_url = '/products/' + item_handle;
    jQuery('.continue-shopping', plc).attr('href', continue_shopping_url);
  }
}

function sc_fnc_get_cart_data(callback) {
 
  setTimeout(function () {
    jQuery.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      cache : false,
    }).done(function (response) {
      
      callback(response);
    }).fail(function (response) {
      //var responseText = JSON.parse(response.responseText);alert(responseText);
      alert(JSON.parse(response.responseText));
      callback([]);
    });
  }, 500);
}

function sc_fnc_load_cart_data() {
  sc_fnc_get_cart_data(function (cart_data) {
    sc_fnc_popualte_data(cart_data, function () {});
  });
}

function sc_fnc_popualte_data(data, callback) {
  console.log(data);
  var plc = jQuery('#sc_cart_slide');
  jQuery('#scli_cart_empty_msg', plc).hide();
  var show_cart_drawer_msg = false;
  var cart_drawer_msg = jQuery('#cart_drawer_msg', plc);
  cart_drawer_msg.hide();
  var cart_drawer_vendor_2_check = jQuery.trim(cart_drawer_msg.data('brand-name-to-check'));
  var items = data.items ? data.items : [];
  var item_count = data.item_count ? data.item_count : 0;
  var cart_subtotal = data.total_price ? data.total_price : 0;
  jQuery('#scl_item_counter', plc).html('(' + item_count + ')');
  var scl_items_plc_html = '<div class="scli_plc">';
  var scl_items_plc = jQuery('#scl_items', plc);
  var items_count = items.length;
  $('.sc-cart-item-count').html(data.item_count);

  if (items_count == 0) {
    $('#scli_cart_empty_msg', plc).show(); //setTimeout(function(){sc_fnc_hide_sc_cart_slide();}, 10000);
  }
  
  

  jQuery.getJSON('/cart.js', function(cart) {
    let items = cart.items;
    var count = cart.item_count
    var length = items.length
    //   alert(length);
    if (length > 2) {
      jQuery('.viewEntireCart').show();
    }else{
      jQuery('.viewEntireCart').hide();
    }
  });

  
  
  

  for (var i = 0; i < items_count; i++) {
    var item = items[i];
    var item_id = item.id ? item.id : '';
    var item_variant_id = item.variant_id ? item.variant_id : '';
    var product_title = item.title ? item.product_title : '';
    var variant_title = item.title ? item.variant_title : '';
    var item_title = item.title ? item.title : '';
    var item_vendor = item.vendor ? item.vendor : '';
    if (cart_drawer_vendor_2_check && cart_drawer_vendor_2_check == item_vendor) show_cart_drawer_msg = true;
    var item_quantity = item.quantity ? item.quantity : 0;
    var item_url = item.url ? item.url : '';
    var item_handle = item.handle ? item.handle : '';
    var item_image = item.image ? item.image : '';
    var item_requires_shipping = item.requires_shipping ? item.requires_shipping : true;
    var item_price = item.price ? item.price : 0;
    var original_price = item.original_price ? item.original_price : 0;
    var discounted_price = item.discounted_price ? item.discounted_price : 0;
    var item_price = item.price ? item.price : 0;
    var final_price = item.price ? item.final_price : 0;
    var item_price_lbl = final_price / 100;
    item_price_lbl = window.currencySymbol + item_price_lbl.toFixed(2);

    if (original_price > 0 && discounted_price > 0 && original_price > discounted_price) {
      var tmp_op = original_price / 100;
      var tmp_dp = discounted_price / 100;
      item_price_lbl = '<del>' + window.currencySymbol + tmp_op.toFixed(2) + '</del>' + '<br />' + window.currencySymbol + tmp_dp.toFixed(2);
    }

    if (!item_id) continue;
    if (!item_variant_id) continue;
    if (!item_quantity) continue;
    var str = '<div class="scli_row">';
    str += '<div class="scli_cell scli_cell_img">';
    if (item_image) str += '<img src="' + item_image + '"/>';
    str += '</div>';
    str += '<div class="scli_cell scli_cell_title">';
    str += '<a href="' + item_url + '" class="scli_product_title">' + product_title + '</a>';
    str += '<br /><span class="scli_variant_title">' + variant_title + '</span>';
    str += '<br /><span class="scli_item_price">' + item_price_lbl + '</span>';
    str += '</div>';
    str += '<div class="scli_cell scli_cell_qty">'; //str+= ''+item_quantity+'';

    /**/

    str += '<div class="qty_box" data-item_id="' + item_id + '" data-qty="' + item_quantity + '">\
<div class="qty_lbl">' + item_quantity + '</div>\
<div class="qty_ctrl">\
<div class="qty_ctrl_plus"> + </div>\
<div class="qty_ctrl_minus" style="height: 30px;"> - </div>\
</div>\
</div>';
    str += '<a class="scli_remove_btn" onclick="sc_fnc_scli_remove_item(' + item_id + ');">Remove</a>';
    /**/

    str += '</div>';
    str += '</div>';
    scl_items_plc_html += str;
  }

  scl_items_plc_html += '</div>';
  scl_items_plc.html(scl_items_plc_html);
  var cart_subtotal_lbl = cart_subtotal / 100;
  cart_subtotal_lbl = cart_subtotal_lbl.toFixed(2);
  jQuery('#scli_subtotal', plc).html(window.currencySymbol + cart_subtotal_lbl);
  if (show_cart_drawer_msg) cart_drawer_msg.show();
  if (typeof callback == 'function') callback();
}

function sc_fnc_show_sc_cart_slide() {
  jQuery('#sc_cart_slide_overlay').fadeIn(); //jQuery('#sc_cart_slide').fadeIn();

  jQuery('#sc_cart_slide').css('right', '-400px').show().animate({
    right: '0px'
  }, 500, function () {});
}

function sc_fnc_hide_sc_cart_slide() {
  jQuery('#sc_cart_slide_overlay').hide(); //jQuery('#sc_cart_slide').hide();

  jQuery('#sc_cart_slide').css('right', '0px').show().animate({
    right: '-500px'
  }, 500, function () {});
}

function sc_fnc_scli_change_item_qty(item_id, qty) {
  if (!item_id) return false;
  jQuery.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: {
      quantity: qty,
      id: item_id
    },
    dataType: 'json'
  }).done(function (response) {
    //console.log('cart add response:');console.log(response);
    jQuery.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json'
    }).done(function (response) {
      //if (_this.settings.cartRedirection) return location.href = '/cart';
      //console.log('cart get response:');console.log(response);
      sc_fnc_load_cart_data(response, function () {//sc_fnc_show_sc_cart_slide();
      });
    });
  }).fail(function (response) {
    var responseText = JSON.parse(response.responseText);
    alert(responseText);
  });
}

function sc_fnc_scli_remove_item(item_id) {
  sc_fnc_scli_change_item_qty(item_id, 0);
  /** /
  if (!item_id) return false;
  jQuery.ajax({
  type: 'POST',
  url: '/cart/change.js',
  data: {quantity: 0, id: item_id},
  dataType: 'json'
  }).done(function (response) {
  //console.log('cart add response:');console.log(response);
  	jQuery.ajax({
  	type: 'GET',
  	url: '/cart.js',
  	dataType: 'json'
  }).done(function (response) {
  	//if (_this.settings.cartRedirection) return location.href = '/cart';
  	//console.log('cart get response:');console.log(response);
  	sc_fnc_popualte_data(response, function(){
  		//sc_fnc_show_sc_cart_slide();
  	});
  });
  }).fail(function (response) {
  var responseText = JSON.parse(response.responseText);
  alert(responseText);
  });
  /**/
      jQuery.getJSON('/cart.js', function(cart) {
      let items = cart.items;
      var count = cart.item_count
      var length = items.length
      //   alert(length);
      if (length > 2) {
        jQuery('.viewEntireCart').show();
      }else{
        jQuery('.viewEntireCart').hide();
      }
    });
}